import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';


interface CheckStatusIsConfirmedProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class CheckStatusIsConfirmed extends React.Component<CheckStatusIsConfirmedProps, any> {
	constructor(props) {
		super(props);

	}

	render() {

		const { values } = this.props;
		
			;
		return (
			<React.Fragment>
				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }}>

					<p style={{ margin: '7px' }}
					>Check if the quote status change to confirmed</p>

					
				</div>



			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/check-quote-is-confirmed.tsx